import { Controller } from "@hotwired/stimulus"
import PullToRefresh from 'pulltorefreshjs'
import { MAIN_NAVIGATION_OPEN_BODY_CLASS } from './main_navigation_controller'

// Connects to data-controller="pull-to-refresh"
export default class extends Controller {
  static values = {
    pull: String,
    release: String,
    refreshing: String,
  }

  connect() {
    PullToRefresh.destroyAll()

    PullToRefresh.init({
      instructionsPullToRefresh: this.pullValue,
      instructionsReleaseToRefresh: this.releaseValue,
      instructionsRefreshing: this.refreshingValue,
      distReload: 70,
      distMax: 70,
      shouldPullToRefresh: () => !window.scrollY && !document.body.classList.contains("modal-is-open") && !document.body.classList.contains(MAIN_NAVIGATION_OPEN_BODY_CLASS),
    })
  }

  disconnect() {
    PullToRefresh.destroyAll()
  }
}
